import { getFlagUrl, isProd } from 'shared/utils'

export interface LanguageOption {
  label: string
  value: string
  icon: string
  alternativeValue?: string
  isDisabled?: boolean
}

export const LANGUAGES: LanguageOption[] = [
  {
    label: 'English',
    value: 'en',
    icon: getFlagUrl('gb'),
    alternativeValue: 'en-US'
  },
  {
    label: 'Deutsch',
    value: 'de',
    icon: getFlagUrl('de')
  },
  {
    label: 'Français',
    value: 'fr',
    icon: getFlagUrl('fr')
  },
  {
    label: 'Español',
    value: 'es',
    icon: getFlagUrl('es')
  },
  {
    label: 'Italiano',
    value: 'it',
    icon: getFlagUrl('it')
  },
  {
    label: 'Português',
    value: 'pt',
    icon: getFlagUrl('pt')
  },
  {
    label: '简体中文',
    value: 'zh',
    isDisabled: isProd(),
    // getFlagUrl takes an ISO COUNTRY code, not a language code (note 'en' -> 'gb'
    // above). The CDN serves flags/cn.svg; flags/zh.svg returns 403.
    icon: getFlagUrl('cn')
  }
].filter(language => !language.isDisabled)

export const DEFAULT_LANGUAGE = 'de'
